define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EntitySysStatusDomain = void 0;
    class EntitySysStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: EntitySysStatusDomain.Active, value: "Active" },
                    { key: EntitySysStatusDomain.Archived, value: "Archived" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[EntitySysStatusDomain.Active] = 0;
                this.KeyIndex[EntitySysStatusDomain.Archived] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Active"] = 0;
                this.ValueIndex["Archived"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.EntitySysStatusDomain = EntitySysStatusDomain;
    Object.defineProperty(EntitySysStatusDomain, "Active", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(EntitySysStatusDomain, "Archived", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(EntitySysStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
